export default __webpack_public_path__ + "static/media/point_start.d5256d5e.svg";